<template>
  <section class="hero primary-light bg-img">
    <div id="header" class="hero-body">
      <div id="info-head" class="container">
        <div class="columns is-mobile is-centered">
          <div class="column">
            <h2 class="subtitle is-4 has-text-centered animated fadeIn delay-1s">
              Hey there
            </h2>
            <h1 class="title is-1 has-text-centered animated delay-1s bounceInRight">
              I'm Andrew Diana
            </h1>
            <h2 class="subtitle is-3 animated has-text-centered animated bounceInUp delay-2s">
              | Full Stack Web Developer |
            </h2>
          </div>
          </div>
          <div class="columns is-centered animated delay-3s fadeIn icons">
            <div class="column is-half is-mobile">
              <nav class="level is-mobile">
              <div class="level-item has-text-centered">
                <div>
                  <a href="https://github.com/axd7832" target="blank">
                    <img height="32" width="32" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/github.svg" />
                  </a>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <a target="_blank" href="https://www.linkedin.com/in/axd7832/">
                  <img height="32" width="32" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/linkedin.svg" />
                  </a>
              </div>
              <div class="level-item has-text-centered">
                <a href="https://www.facebook.com/Adiana97" target="blank">
                  <img height="32" width="32" src="https://cdn.jsdelivr.net/npm/simple-icons@latest/icons/facebook.svg" />
                </a>
              </div>
            </nav>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>


<script>
  export default {
    name: 'Header',
    data () {
      return {

      }
    }
  }
</script>

<style scoped>
  #header {
    min-height: 100vh;
  }
  #info-head {
    margin-top: 25vh;
  }
  .bg-img{ 
        background-image: url("../assets/bgImg.jpg") ;
        background-position: center center;
        background-repeat:  no-repeat;
        background-attachment: fixed;
        background-size:  cover;
        background-color: #999;
  }
  .bg-img::before{
    content: "";
    filter: blur(100px);
  }

  @media only screen and (max-width: 600px) {
    .title.is-1 {
      font-size: 2em;
    }
    .subtitle.is-3 {
      font-size: 1.5em;
    }
  }
  

</style>
